const messages = {
  pt: {
    translations: {
      callbacks: {
        title: "Callbacks",
        subtitle:
          "Avisamos um endereço seu toda vez que um evento acontece na plataforma. O aviso é enviado uma vez — se o endereço estiver fora do ar naquele momento, ele não é reenviado.",
        add: "Adicionar destino",
        emptyTitle: "Nenhum destino cadastrado",
        emptyText: "Cadastre um endereço para receber avisos quando algo acontecer aqui.",
        search: "Buscar por endereço, descrição ou evento",
        event: "Evento",
        allEvents: "Todos os eventos",
        situation: "Situação",
        all: "Todas",
        receiving: "Recebendo",
        paused: "Pausados",
        failing: "Com falha no último envio",
        clear: "Limpar",
        noMatch: "Nenhum destino corresponde ao filtro.",
        orphanChip: "evento indisponível",
        orphanTooltip:
          "O plugin que anunciava este evento não está mais instalado — este destino não recebe nada.",
        signedTooltip: "Enviamos a assinatura do conteúdo",
        activeTooltip: "Receber avisos",
        pausedTooltip: "Pausado",
        testTooltip: "Enviar um aviso de teste agora",
        waitingFirst: "aguardando o primeiro evento",
        received: "recebeu",
        failed: "falhou",
        answered: "Respondeu {{status}}",
        editTitle: "Editar destino",
        newTitle: "Novo destino",
        modalSubtitle: "Escolha o que avisar e para onde enviar.",
        sectionWhen: "Quando avisar",
        sectionWhere: "Para onde enviar",
        sectionSecurity: "Segurança",
        searchHint: "Digite para buscar",
        soon: "em breve",
        noEvent: "Nenhum evento com esse nome",
        weWarnWhen: "Avisamos quando {{description}}.",
        url: "Endereço",
        urlPlaceholder: "https://seu-sistema.com.br/avisos",
        urlInvalid: "O endereço precisa começar com http:// ou https://",
        urlHelp:
          "Enviamos um POST com o conteúdo em JSON. Responda 2xx em até 10 segundos.",
        description: "Descrição",
        descriptionPlaceholder: "Para que serve este destino",
        secret: "Segredo",
        secretUnchanged: "••••••  (inalterado)",
        secretOptional: "opcional",
        secretExists:
          "Já existe um segredo. Deixe em branco para manter, ou digite outro para substituir.",
        secretHelp:
          "Com um segredo, assinamos cada envio no cabeçalho X-Markedesk-Signature — assim seu sistema confirma que o aviso veio daqui.",
        seeRequest: "Ver a requisição que enviamos",
        cancel: "Cancelar",
        save: "Salvar alterações",
        create: "Cadastrar destino",
        saved: "Destino salvo",
        created: "Destino cadastrado",
        removed: "Destino removido",
        removeTitle: "Remover destino",
        removeText: "{{url}} deixa de receber os avisos de {{event}}.",
        testFailed: "Seu sistema respondeu: {{error}}",
        testOk: "Recebido — respondeu {{status}} em {{duration}}ms",
        samplePath: "/seu-endereco",
        sampleContent: "conteúdo do evento",
      },
      eventCatalog: {
        groups: {
          atendimento: "Atendimento",
          mensagem: "Mensagem",
          contato: "Contato",
          conexao: "Conexão",
          usuario: "Usuário",
          plataforma: "Plataforma",
        },
        ticket_created: {
          label: "Atendimento aberto",
          description: "chegou uma conversa nova",
        },
        ticket_updated: {
          label: "Atendimento alterado",
          description: "mudou algum dado do atendimento",
        },
        ticket_assigned: {
          label: "Atendimento aceito",
          description: "um atendente assumiu a conversa",
        },
        ticket_transferred: {
          label: "Atendimento transferido",
          description: "mudou de fila ou de atendente",
        },
        ticket_closed: {
          label: "Atendimento finalizado",
          description: "a conversa foi encerrada",
        },
        ticket_reopened: {
          label: "Atendimento reaberto",
          description: "o contato voltou a falar depois de encerrado",
        },
        ticket_deleted: {
          label: "Atendimento excluído",
          description: "o atendimento foi apagado",
        },
        ticket_tagged: {
          label: "Tag adicionada ao atendimento",
          description: "marcaram o atendimento com uma tag",
        },
        ticket_untagged: {
          label: "Tag removida do atendimento",
          description: "tiraram uma tag do atendimento",
        },
        ticket_messageReceived: {
          label: "Mensagem recebida",
          description: "o contato enviou algo",
        },
        ticket_messageSent: {
          label: "Mensagem enviada",
          description: "a plataforma enviou algo",
        },
        ticket_messageEdited: {
          label: "Mensagem editada",
          description: "o autor mudou o conteúdo depois de enviar",
        },
        ticket_messageDeleted: {
          label: "Mensagem apagada",
          description: "a mensagem foi removida da conversa",
        },
        ticket_messageReacted: {
          label: "Reação na mensagem",
          description: "alguém reagiu com um emoji",
        },
        message_sent: {
          label: "Mensagem enviada (sem ticket)",
          description: "envio avulso, fora de um atendimento",
        },
        message_edited: {
          label: "Mensagem editada (sem ticket)",
          description: "edição de envio avulso",
        },
        message_deleted: {
          label: "Mensagem apagada (sem ticket)",
          description: "exclusão de envio avulso",
        },
        message_reacted: {
          label: "Reação (sem ticket)",
          description: "reação em envio avulso",
        },
        message_ackChanged: {
          label: "Confirmação de entrega",
          description: "a mensagem foi entregue ou lida",
        },
        message_mediaRetried: {
          label: "Mídia rebaixada",
          description: "tentamos baixar o arquivo de novo",
        },
        message_received: {
          label: "Mensagem recebida (sem ticket)",
          description: "recebimento fora de um atendimento",
        },
        contact_created: {
          label: "Contato criado",
          description: "um contato novo entrou na base",
        },
        contact_updated: {
          label: "Contato alterado",
          description: "mudou nome, número ou dado do contato",
        },
        contact_deleted: {
          label: "Contato excluído",
          description: "o contato foi removido",
        },
        contact_tagged: {
          label: "Tag adicionada ao contato",
          description: "marcaram o contato com uma tag",
        },
        contact_untagged: {
          label: "Tag removida do contato",
          description: "tiraram uma tag do contato",
        },
        connection_created: {
          label: "Conexão criada",
          description: "cadastraram uma conexão nova",
        },
        connection_updated: {
          label: "Conexão alterada",
          description: "mudou a configuração da conexão",
        },
        connection_deleted: {
          label: "Conexão excluída",
          description: "a conexão foi removida",
        },
        connection_statusChanged: {
          label: "Conexão mudou de status",
          description: "conectou, caiu ou pediu leitura do código",
        },
        connection_disconnected: {
          label: "Conexão caiu",
          description: "a conexão perdeu o vínculo",
        },
        connection_qrcodeReceived: {
          label: "Código de leitura gerado",
          description: "há um QR novo esperando leitura",
        },
        connection_rateLimited: {
          label: "Conexão limitada",
          description: "o provedor começou a recusar por excesso",
        },
        user_created: {
          label: "Usuário criado",
          description: "um usuário novo entrou na empresa",
        },
        user_updated: {
          label: "Usuário alterado",
          description: "mudou dado ou permissão do usuário",
        },
        user_deleted: {
          label: "Usuário excluído",
          description: "o usuário foi removido",
        },
        company_created: {
          label: "Empresa cadastrada",
          description: "alguém concluiu o cadastro pelo site",
        },
        company_updated: {
          label: "Empresa alterada",
          description: "mudou dado cadastral da empresa",
        },
      },
      badges: {
        new: "Novo",
        beta: "Em testes",
      },
      plugins: {
      abas: { instalados: "Instalados", padroes: "Padrão da plataforma" },
        origem: {
          titulo: "Origem",
          todos: "Todos",
          required: "Obrigatórios",
          company: "Da empresa",
          builtin: "Do produto",
          obrigatorio: "Obrigatório",
          obrigatorioTooltip:
            "Definido como obrigatório pela plataforma — é reinstalado automaticamente se removido",
          vazio: "Nenhum plugin nesta categoria.",
          porMantenedor: "por {{nome}}",
          usaParceiro: " • usa {{nome}}",
        },
        novidades: {
          selo: "Novidades",
          tooltip: "Este plugin foi atualizado desde a última vez que você viu. Abra a ficha para ver o que mudou.",
        },
        sobre: {
          acao: "Sobre e suporte",
          quemMantem: "Quem mantém",
          suporte: "Suporte",
          site: "Site",
          servicoTerceiro: "Serviço de terceiro",
          novidades: "Novidades",
          versaoAtual: "versão atual",
          mudancaImportante: "mudança importante",
          instalacao: "Instalação",
          identificador: "Identificador: {{id}}",
          endereco: "Endereço: {{url}}",
          execucao: "Execução: {{modo}}",
          execucaoRemota: "processo próprio (remoto)",
          execucaoLocal: "dentro do backend",
          semFicha:
            "Este plugin não declarou informações de manutenção e suporte. Em caso de problema, procure quem instalou o plugin nesta empresa.",
          fechar: "Fechar",
          mantenedorTipo: {
            "product-team": "Equipe do produto",
            partner: "Parceiro",
          },
        },
        compat: {
          ctaRegister: "para poder registrá-lo",
          ctaRestore: "para restaurar todas as funcionalidades",
          versionSuffix: " ({{version}})",
          sdkOutdatedMinSuffix: " — este backend exige plugin-sdk >= {{min}}",
          sdkOutdated: "SDK do plugin desatualizado{{versionSuffix}}{{minSuffix}}. Atualize o plugin-sdk no servidor remoto {{cta}}.",
          backendOutdated: "Este plugin exige backend >= {{minBackendVersion}} (este backend está na {{backendVersion}}). Atualize o Markedesk {{cta}}.",
          rangeAnd: "e",
          sdkOutOfRange: "SDK do plugin ({{sdkVersion}}) fora da faixa suportada pelo próprio plugin ({{range}}). Ajuste a versão de plugin-sdk no servidor remoto {{cta}}.",
        },
      },
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          disabled:
            "Cadastro de usuários está desabilitado no momento. Por favor, tente novamente mais tarde.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          company: "Nome da Organização",
          phone: "Whatsapp (DDD + NÚMERO)",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      ticketInfo: {
        copyPhone: "Copiar telefone",
        quickMessages: "Respostas rápidas",
        phonecopied: "Telefone copiado para área de transferência!",
        noPhone: "Nenhum telefone disponível para copiar",
        copyError: "Erro ao copiar telefone",
      },
      login: {
        title: "Login",
        welcome: "Bem-vindo de volta",
        loginInstruction: "Entre com seus dados para acessar sua conta",
        forgotInstruction: "Informe o e-mail cadastrado para receber o link de recuperacao de senha.",
        resetInstruction: "Defina sua nova senha para concluir a recuperacao de acesso.",
        form: {
          email: "Email",
          password: "Senha",
          confirmPassword: "Confirmar senha",
          button: "Acessar",
        },
        buttons: {
          submit: "Entrar",
          forgotPassword: "Esqueci minha senha",
          sendRecovery: "Enviar link de recuperacao",
          backToLogin: "Voltar para o login",
          resetPassword: "Redefinir senha",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      defaultPlugins: {
      titulo: "Plugins padrão da plataforma",
      explicacao:
        "Plugins declarados aqui são obrigatórios: toda empresa recebe a instalação automaticamente e não pode removê-la. Desativar libera a remoção sem apagar o histórico.",
      vazio: "Nenhum plugin padrão declarado.",
      removido: "Plugin removido da lista de padrões.",
      semAcesso: "Somente a empresa dona da plataforma pode configurar os plugins padrão.",
      preview: {
        titulo: "URL que será gerada:",
        invalido: "Molde inválido",
      },
      origem: { instalado: "já instalado em alguma empresa" },
      descoberto: {
        titulo: "Plugin identificado:",
        pendente: "Ainda não provisionado — o plugin será identificado na primeira empresa.",
      },
      emMassa: {
        resultado: "{{afetadas}} empresa(s) processada(s), {{falhas}} falha(s).",
        reapontar: {
          titulo: "Regerar a URL de todas as empresas",
          mensagem:
            "Cada uma das {{empresas}} empresas recebe uma URL nova, gerada pelo molde atual. Por dentro é remover e instalar de novo, então o plugin perde o estado guardado no endereço antigo — canais com sessão precisam reconectar.",
        },
        desinstalar: {
          titulo: "Desinstalar de todas as empresas",
          mensagem:
            "O plugin sai das {{empresas}} empresas e a declaração é desativada. As conexões criadas em cima dele ficam desconectadas. Não tem desfazer.",
        },
      },
      status: { ativo: "Ativo", inativo: "Inativo" },
      campos: {
        plugin: "Plugin (descoberto)",
        baseUrlTemplate: "URL do plugin",
        active: "Obrigatório para todas as empresas",
        instaladoEm: "Empresas com o plugin",
        acoes: "Ações",
      },
      ajuda: {
        baseUrlTemplate:
          "Endereço do plugin por empresa. Use {tenantKey} onde entra a chave gerada. O resto (id, nome, capacidades) vem do próprio plugin no provisionamento.",
      },
      botoes: {
        adicionar: "Adicionar",
        salvar: "Salvar",
        cancelar: "Cancelar",
      },
      modal: {
        tituloNovo: "Novo plugin padrão",
        tituloEditar: "Editar plugin padrão",
        salvo: "Plugin padrão salvo.",
        erros: {
          obrigatorio: "Campo obrigatório",
          idCurto: "Muito curto",
        },
      },
      confirmarRemocao: {
        titulo: "Remover dos padrões:",
        mensagem:
          "As empresas continuam com o plugin instalado, mas ele deixa de ser obrigatório e passa a poder ser removido.",
      },
    },
    companies: {
        title: "Cadastrar Empresa",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        dueDate: {
          expiration: "Sua assinatura expira em",
          days: "dias!",
          day: "dia!",
          expirationToday: "Sua assinatura expira hoje!",
        },
        token: "Token",
      },
      dashboard: {
        filters: "Filtros",
        filter: "FILTRAR ",
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
        },
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
        },
        cards: {
          inAttendance: "Em Atendimento",
          waiting: "Aguardando",
          activeAttendants: "Atendentes Ativos",
          finalized: "Finalizados",
          newContacts: "Novos Contatos",
          totalReceivedMessages: "Mensagens Recebidas",
          totalSentMessages: "Mensagens Enviadas",
          averageServiceTime: "T.M. de Atendimento",
          averageWaitingTime: "T.M. de Espera",
          status: "Status (Atual)",
          activeTickets: "Tickets Ativos",
          passiveTickets: "Tickets Passivos",
          groups: "Grupos",
        },
        users: {
          name: "Nome",
          numberAppointments: "Quantidade de Atendimentos",
          statusNow: "Atual",
          totalCallsUser: "Total de atendimentos por usuario",
          totalAttendances: "Total de atendimentos",
        },
        date: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
        },
        licence: {
          available: "Disponível até",
        },
        assessments: {
          totalCalls: "Total de Atendimentos",
          callsWaitRating: "Atendimentos aguardando avaliação",
          callsWithoutRating: "Atendimentos sem avaliação",
          ratedCalls: "Atendimentos avaliados",
          evaluationIndex: "Índice de avaliação",
          score: "Pontuação",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
        },
      },
      reports: {
        title: "Relatório de Pesquisas Realizadas",

        operator: "Operador",
        period: "Período",
        until: "Até",
        date: "Data",
        reportTitle: "Relatórios",
        calls: "Atendimentos",
        search: "Pesquisas",
        durationCalls: "Duracão dos atendimentos",
        grupoSessions: "Atendimentos em grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          errorToast: "Erro ao gerar o relatório",
          back: "Voltar",
          groupServiceReport: "Relatório de Atendimento em Grupos",
          loading: "Carregando...",
          contact: "Contato",
          dateOpen: "Data abertura",
          dateLastUpdated: "Data Última Atualização",
          agent: "Quem atendeu",
          agentClosed: "Quem fechou",
          waitingAssistance: "Aguardando atendimento",
          process: "Em atendimento",
        },
        researchReports: {
          response: "resposta",
          active: "(Ativa)",
          inactive: "(Inativa)",
          quantity: "Quantidade",
          percentage: "porcentagem",
          title: "Relatório de Pesquisas Realizadas",
          activeSearch: "Pesquisa ativa",
          inactiveSearch: "Pesquisa inativa",
        },
        ticketDurationDetail: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Duração do Atendimento",
          startService: "Início do atendimento",
          lastUpdated: "Última atualização",
          lastAgent: "Último atendente",
          durationFinished: "Duração após finalizado",
        },
        ticketDuration: {
          title: "Relatório de Duração dos Atendimento",
          contact: "Contato",
          open: "Abertos",
          pending: "Pendentes",
          finished: "Finalizados",
          durationFinished: "Duração dos finalizados",
          durationAfterFinished: "Duração após finalizado",
          actions: "Ações",
        },
        ticketReports: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Atendimento",
        },
        exportExcel: {
          title: "Relatórios de Atendimentos",
          startDate: "Data inicial",
          endDate: "Data final",
          notInformed: "Não informado",
          columns: {
            id: "ID",
            connection: "Conexão",
            contact: "Contato",
            user: "Usuário",
            queue: "Fila",
            status: "Status",
            lastMessage: "Última Mensagem",
            openDate: "Data Abertura",
            openTime: "Hora Abertura",
            closeDate: "Data Fechamento",
            closeTime: "Hora Fechamento",
            supportTime: "Tempo de Atendimento",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relação de Atendimentos Realizados",
          exportTitle: "Relação de Atendimentos em Grupos Realizados",
        },
      },
      todo: {
        newTask: "Nova Tarefa",
        add: "Adicionar",
        task: "Tarefas",
      },
      contactImportWpModal: {
        title: "Exportar Contatos para o Excel",
        buttons: {
          downloadModel: "Download modelo do excel para importação",
          closed: "Fechar",
          import: "Selecione o arquivo do excel para importar Contatos",
        },
      },
      connections: {
        title: "Conexões",
        pluginOffline: "com problema de conexão",
        pluginNotInstalled: "não instalado nesta empresa",
        waitConnection: "Aguarde... Suas conexões serão reiniciadas!",
        newConnection: "Nova Conexão",
        restartConnections: "Reiniciar Conexões",
        callSupport: "Chamar Suporte",
        newConnection: "Nova Conexão",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecte seus canais de atendimento para receber mensagens e iniciar conversas com seus clientes.",
        client: "Cliente",
        connectedConnections: " Conexões conectadas ",
        disconnectedConnections: "Conexões desconectadas ",
        totalConnections: " Total de Conexões",
        total: "Total",
        connections: "Conexões de:",

        toasts: {
          deleted: "Conexão excluída com sucesso!",
          closedimported:
            "Estamos fechando os tickets importados, por favor aguarde uns instantes",
        },
        confirmationModal: {
          closedImportedTitle: "Fechar tickets importados",
          closedImportedMessage:
            "Se você confirmar todos os tickets importados serão fechados",
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar Conexão",
          disconnect: "desconectar",
          restart: "Reiniciar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          closedImported: "Fechar todos os tickets Importados",
          preparing: "Preparando mensagens para importação",
          importing: "Importando Mensagens do WhatsApp",
          newQr: "Novo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data da mensagem",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          syncing: {
            title: "Sincronizando mensagens...",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          version: "Versão",
          defaultVersion: "Padrão",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
          number: "Número do Whatsapp",
          color: "Cor",
        },
      },
      syncOverlay: {
        title: "Sincronizando",
        subtitle: "Recebendo mensagens do WhatsApp...",
        seconds: "segundos",
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimento Existente",
        },
        form: {
          message: "Este contato já está em atendimento:",
          user: "Atendente",
          queue: "Fila",
          messageWait:
            "Este contato já está aguardando atendimento. Veja na aba Aguardando!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket criado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " iniciou o atendimento.",
          access: "acessou o ticket.",
          transfered: "transferiu o ticket.",
          receivedTransfer: "recebeu o ticket transferido.",
          pending: "devolveu a fila.",
          closed: "fechou o ticket",
          reopen: "reabriu o ticket",
          redirect: "- redirecionado",
          clientClosed: "Cliente fechou o ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar Conexão",
          edit: "Editar Conexão",
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "NPS",
          integrations: "Integrações",
          schedules: "Horário de expediente",
        },
        form: {
          importOldMessagesEnable: "Importar histórico",
          importOldMessagesDescription: "Importa mensagens das últimas 24h ao conectar",
          importOldMessagesDisabled: "Funcionalidade temporariamente desabilitada para melhorias",
          importOldMessages: "Data de inicio da importação",
          importRecentMessages: "Data de termino da importação",
          importOldMessagesGroups: "Incluir grupos",
          closedTicketsPostImported: "Encerrar tickets",
          name: "Nome",
          queueRedirection: "Redirecionamento de Fila",
          queueRedirectionDesc:
            "Selecione uma fila para os contatos que não possuem fila serem redirecionados",
          default: "Padrão",
          group: "Permitir grupos",
          timeSendQueue: "Tempo em minutos para redirecionar para fila",
          importAlert:
            "ATENÇÃO: Ao salvar, sua conexão será encerrada e será necessário ler novamente o QR Code. As mensagens das últimas 24h serão importadas ao reconectar.",
          enablePendingMessages: "Ativar processamento de mensagens atrasadas",
          sendCallMessage: "Enviar mensagem ao receber chamada",
          rejectCalls: "Recusar chamada automaticamente",
          rejectCallsMessage: "Mensagem ao receber chamada",
          rejectCallsMessageHelp:
            "Enviada ao contato quando ele liga (ex: 'Não atendemos chamadas, envie uma mensagem').",
          groupAsTicket: "Tratar grupos como ticket",
          whatsappVersion: "Versao do WhatsApp",
          defaultVersion: "Usar versao padrao",
          timeCreateNewTicket: "Criar novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x vezes",
          maxUseInactiveTime: "Enviar flow de inatividade x vezes",
          timeUseBotQueues: "Enviar bot em x minutos",
          timeToReturnQueue: "Tempo para retornar a fila em minutos",
          timeAwaitActiveFlow: "Tempo para aguardar ativação do fluxo",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresTicketNPS:
            "Encerrar chats aguardando avaliação após x minutos",
          maxUseBotQueuesNPS:
            "Quantidade máxima de vezes que a avaliaçao vai ser enviada",
          closeLastMessageOptions1: "Do atendente/Cliente",
          closeLastMessageOptions2: "Do atendente",
          outOfHoursMessage: "Mensagem de fora de expediente",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          lgpdLinkPrivacy: "Link para política de privacidade",
          lgpdMessage: "Mensagem de saudaçao LGPD",
          lgpdDeletedMessages: "Ofuscar mensagem apagada pelo contato",
          lgpdSendMessage: "Sempre solicitar confirmação do contato",
          ratingMessage: "Mensagem de avaliaçao - Escala deve ser de 0 a 10",
          token: "Token para integração externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensagem de inatividade",
          timeInactiveMessage:
            "Tempo em minutos para envio do aviso de inatividade",
          flowInactiveTime:
            "Tempo em minutos para envio do flow de inatividade",
          whenExpiresTicket:
            "Encerrar chats abertos quando última mensagem for",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          prompt: "Prompt",
          collectiveVacationEnd: "Data final",
          collectiveVacationStart: "Data inicial",
          collectiveVacationMessage: "Mensagem de férias coletivas",
          queueIdImportMessages: "Fila de importação",
          isOficial: "Oficial",
          phone_number_id: "ID Número de telefone",
          waba_id: "Waba ID",
          send_token: "Token de envio",
          business_id: "ID do negócio",
          phone_number: "Número de telefone",
          triggerIntegrationOnClose: "Disparar Integração ao Encerrar Ticket",
          enableIntegration: "Habilitar Integração",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
          minutes: "minutos",
        },
        success: "Conexão salvo com sucesso.",
        errorSendQueue:
          "Foi informado tempo para redirecionar fila, porém não foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos",
        errorExpiresNPS:
          "É obrigado informar um tempo para avaliação quando se utiliza o NPS.",
        errorRatingMessage:
          "É obrigado informar uma mensagem de avaliação quando se utiliza o NPS.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        import: {
          error: "Erro na Importação",
          completed: "Importação Concluída",
          importing: "Importando Contatos",
          fileName: "Arquivo",
          errorMessage: "Erro",
          processingFile: "Processando arquivo",
          contacts: "contatos",
          created: "Criados",
          updated: "Atualizados",
          skipped: "Ignorados",
          errors: "Erros",
          fileCompleted: "Arquivo totalmente importado!",
          lastTaskSummary: "Resumo da Última Tarefa",
          totalProcessed: "Total Processado",
          completedFiles: "Arquivos Concluídos",
          estimatedTime: "Previsão",
        },
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        conversationFlows: " Fluxos de Conversa",
        addFlow: "Adicionar Fluxo",
        editFlow: "Editar Fluxo ",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          blockContact: "Tem certeza que deseja bloquear este contato?",
          unblockContact: "Tem certeza que deseja desbloquear este contato?",
          importMessage: "Deseja importar todos os contatos do telefone?",
          importChat: "Importar Conversas",
          wantImport: "Deseja importar todas as conversas do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contato",
        },
        loading: "Carregando...",
        loadMore: "Carregar Mais",
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          email: "Email",
          actions: "Ações",
          lastMessage: "Última Mensagem",
          wallet: "Carteira",
        },
        menu: {
          importYourPhone: "Importar do aparelho padrão",
          importRunning: "Importacao em andamento...",
          importToExcel: "Importar / Exportar do Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Encaminhada",
      },
      forwardMessageModal: {
        title: "Encaminhar mensagem",
        buttons: {
          ok: "Encaminhar",
        },
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
          voiceKey: "Chave da API de Voz",
          voiceRegion: "Região de Voz",
        },
        success: "Prompt salvo com sucesso!",
        title: {
          add: "Adicionar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo Tokens Resposta",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        buttons: {
          add: "Adicionar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          chatBotContact: "Desabilitar chatbot",
          termsLGDP: "Termos LGPD aceito em:",
          whatsapp: "Conexão Origem: ",
          assignWallet: "Carteira de Cliente",
          numberChecking: "Verificando número...",
          numberValid: "Número válido no WhatsApp",
          numberInvalid: "Número não encontrado no WhatsApp",
          numberInvalidWarning: "Não conseguimos validar o número no WhatsApp. Se quiser continuar mesmo assim, tenha em mente que enviar mensagens para números que não existem pode resultar em punição do WhatsApp.",
          numberInvalidConfirmTitle: "Número não validado",
          existingContact: "Buscar contato já cadastrado",
          existingContactNoOptions: "Nenhum contato encontrado",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          useAnyway: "Usar mesmo assim",
        },
        success: "Contato salvo com sucesso.",
        walletLinked: "Contato vinculado à sua carteira com sucesso!",
        walletError: "Usuário não possui filas associadas",
        saveFirst: "Contato deve ser salvo primeiro",
        linkWallet: "Vincular à minha carteira",
      },
      wallets: {
        title: "Carteiras de Contatos",
        searchPlaceholder: "Buscar contatos...",
        filterByUser: "Filtrar por Usuário",
        allUsers: "Todos os usuários",
        contact: "Contato",
        user: "Usuário",
        queue: "Fila",
        phone: "Telefone",
        email: "Email",
        actions: "Ações",
        editWallet: "Editar Carteira",
        selectUser: "Selecionar Usuário",
        selectQueue: "Selecionar Fila",
        selectUserAndQueue: "Selecione um usuário e uma fila",
        cancel: "Cancelar",
        save: "Salvar",
        confirmDeleteTitle: "Confirmar Exclusão",
        confirmDeleteMessage:
          "Tem certeza que deseja remover este contato da carteira?",
        deleteSuccess: "Contato removido da carteira com sucesso!",
        updateSuccess: "Carteira atualizada com sucesso!",
        wallet: "Carteira",
      },
      queueModal: {
        title: {
          queueData: "Dados da fila",
          text: "Horários de atendimento",
          add: "Adicionar fila",
          edit: "Editar fila",
          confirmationDelete:
            "Tem certeza? Todas as opções de integrações serão deletadas.",
        },
        form: {
          name: "Nome",
          color: "Cor",
          orderQueue: "Ordem da fila (Bot)",
          rotate: "Rodízio",
          timeRotate: "Tempo de Rodízio",
          typeRandomMode: "Tipo de rodízio",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          token: "Token",
          integrationId: "Integração",
          fileListId: "Lista de arquivos",
          closeTicket: "Fechar ticket",
          randomizeImmediate: "Randomizar Automaticamente (Imediato)",
          queueType: "Tipo de menu",
          message: "Mensagem de retorno",
          queue: "Fila para transferência",
          integration: "Integração",
          file: "Lista de arquivos",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opções",
          toolTipTitle: "Adicione opções para construir um chatbot",
          toolTip:
            "Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante",
          selectOption: "Selecione uma opção",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "Integração",
          file: "Arquivo",
          toolTipMessageTitle:
            "A mensagem é obrigatória para seguir ao próximo nível",
          toolTipMessageContent:
            "A mensagem é obrigatória para seguir ao próximo nível",
          selectUser: "Selecione um Usuário",
          selectQueue: "Selecione uma Fila",
          selectIntegration: "Selecione uma Integração",
          addOptions: "Adicionar opções",
        },
        serviceHours: {
          dayWeek: "Dia da semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
      userModal: {
        warning:
          "Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!",
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
          updateImage: "Atualizar imagem",
          removeImage: "Excluir imagem",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          farewellMessage: "Mensagem de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          whatsapp: "Conexão Padrão",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Desabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Aberto",
          defaultMenuClosed: "Fechado",
          defaultMenu: "Menu padrão",
          defaultTheme: "Tema Padrão",
          defaultThemeDark: "Escuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversas de outras filas",
          historyQueues: "Visualizar histórico de outras filas",
          historyQueuesHint: "Filas EXTRAS cujo histórico o usuário pode ver, sem atendê-las. As filas que ele atende já mostram o histórico automaticamente.",
          attendanceQueues: "Filas de atendimento",
          attendanceQueuesHint: "Filas que o usuário atende. O histórico dessas filas já fica visível automaticamente.",
          whatsappHint: "Conexão padrão usada pelo usuário para iniciar conversas.",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Desabilitado",
          allUserChat: "Ver conversas de outros usuários",
          userClosePendingTicket: "Permitir fechar tickets pendentes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendentes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atendimentos",
          allowConnections: "Permitir ações nas conexões",
          showContacts: "Ver contatos",
          showCampaign: "Ver campanhas",
          showFlow: "Ver fluxos",
        },
        tabs: {
          general: "Geral",
          queues: "Filas e Conexão",
          permissions: "Permissões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem",
          editImage: "Editar Imagem",
        },
        success: "Usuário salvo com sucesso.",
      },
      companyModal: {
        title: {
          add: "Adicionar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nome",
          email: "Email",
          passwordDefault: "Senha",
          owner: "Usuário principal",
          ownerNone: "Nenhum",
          ownerHelp: "O usuário principal não é bloqueado pelo horário de trabalho, para poder corrigir configurações erradas.",
          plan: "Plano",
          planSelect: "Selecione um plano",
          active: "Ativo",
          nameRequired: "Nome é obrigatório",
          nameShort: "Nome muito curto",
          nameLong: "Nome muito longo",
          emailInvalid: "Email é inválido",
          emailRequired: "E-mail é obrigatório",
          planRequired: "Plano é obrigatório",
          numberAttendants: "Usuários",
          numberConections: "Conexões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Empresa salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
          message: "Mensagem",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          assinar: "Enviar Assinatura",
          isInternal: "Comunicação interna (não envia ao contato)",
          isInternalHelp: "A mensagem entra no ticket como nota interna, visível só para a equipe.",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addSchedule: "Adicionar agendamento",
        },
        success: "Agendamento salvo com sucesso.",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
          addKanban: "Nova Lane",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nome",
          color: "Cor",
          timeLane: "Tempo em minutos para redirecionar para lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Mensagem de saudação da lane",
          mediaFiles: "Mídia",
          rollbackLaneId: "Voltar para Lane após retomar atendimento",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salva com sucesso.",
        successKanban: "Lane salva com sucesso.",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
        yes: "SIM",
        not: "NÃO",
        buttons: {
          newTicket: "Novo",
          resolveAll: "Resolver Todos",
          close: "Fechar",
          new: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        messageHidden: "Mensagem oculta",
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abertos",
          resolverd: "Resolvidos",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
          messageHidden: "Mensagem oculta",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
          filterConections: "Filtro por Conexão",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Filtro por Usuarios",
          filterContacts: "Filtro por Contatos",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver",
          scredule: "Agendamento",
          schedule: "Agendar",
          deleteTicket: "Deletar Ticket",
          transfer: "Transferir",
          transferTickets: "Transferir Tickets",
          transferToAttendant: "Transferir para atendente",
          voiceCall: "Ligação",
          spy: "Espiar",
        },
        closedTicket: {
          closedMessage: "Fechar Ticket Com Mensagem de Despedida",
          closedNotMessage: "Fechar Ticket Sem Mensagem de Despedida",
        },
      },
      ticket: {
        spyBanner: "Modo espiar — sem marcar como lido",
        spyNoMessages: "Nenhuma mensagem encontrada",
        spyMediaLocation: "Localização",
        spyMediaContact: "Contato",
        spyMediaAudio: "Áudio",
        spyMediaVideo: "Vídeo",
        spyMediaDocument: "Documento",
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldWhatsapp: "Selecione um whatsapp",
        noOptions: "Nenhum usuário encontrado com esse nome",
        msgTransfer: "Observações - mensagem interna, não vai para o cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Criar grupo",
        modal: {
          conversation: "Conversa",
          title: "Nome",
          filterUsers: "Selecione integrantes",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsList: {
        called: "Chamado",
        today: "Hoje",
        missedCall: "Chamada de voz/vídeo perdida às",
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        noQueue: "Sem Fila",
        buttons: {
          accept: "Aceitar",
          cancel: "Cancelar",
          start: "iniciar",
          closed: "Fechar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          createNew: "Novo",
          createNewTicket: "Criar Novo Ticket",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opções de Kanban",
        },
        acceptModal: {
          title: "Aceitar Chat",
          queue: "Selecionar setor",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contato",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          chatsTempoReal: "Painel",
          tickets: "Atendimentos",
          quickMessages: "Respostas rápidas",
          contacts: "Contatos",
          wallets: "Carteiras",
          queues: "Filas & Chatbot",
          tags: "Tags",
          administration: "Administração",
          companies: "Empresas",
          defaultPlugins: "Plugins padrão",
          whatsappVersions: "Versoes WhatsApp",
          users: "Usuários",
          birthdaySettings: "Config. Aniversário",
          settings: "Configurações",
          files: "Lista de arquivos",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          queueIntegration: "Integrações",
          version: "Versão",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Gerenciar conexões",
          reports: "Relatórios",
          management: "Gerência",
          callHistorical: "Histórico de Chamadas",
          externalLinks: "Links Externos",
          tasks: "Tarefas",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            message: "Olá",
            messageEnd: "seja bem-vindo a",
            active: "Ativo até",
            goodMorning: "Oi,",
            myName: "meu nome é",
            continuity: "e darei continuidade em seu atendimento.",
            virtualAssistant: "Assistente Virtual",
            token:
              "Token inválido, por favor entre em contato com o administrador da plataforma.",
          },
          message: {
            location: "Localização",
            contact: "Contato",
          },
          notRegister: "Nenhum registro",
          refresh: "Atualizar",
          socketStatus: {
            connected: "Tempo real conectado",
            connecting: "Conectando ao tempo real…",
            reconnecting: "Reconectando ao tempo real…",
            disconnected: "Tempo real desconectado",
            slow: "Tempo real lento — {{ms}} ms de atraso",
          },
        },
      },
      tasks: {
        title: "Tarefas",
        searchPlaceholder: "Buscar tarefas...",
        noTasks: "Nenhuma tarefa encontrada. Crie uma nova tarefa!",
        buttons: {
          newTask: "Nova Tarefa",
          cancel: "Cancelar",
          save: "Salvar",
          create: "Criar",
        },
        toasts: {
          created: "Tarefa criada com sucesso!",
          updated: "Tarefa atualizada com sucesso!",
          deleted: "Tarefa excluída com sucesso!",
          completed: "Tarefa concluída!",
          reopened: "Tarefa reaberta!",
        },
        validation: {
          titleRequired: "O título da tarefa é obrigatório.",
          reminderNeedsTime: "Para usar o lembrete, defina o horário de início da tarefa.",
        },
        stats: {
          total: "Total",
          completed: "Concluídas",
          pending: "Pendentes",
          highPriority: "Alta",
          mediumPriority: "Média",
          lowPriority: "Baixa",
        },
        filters: {
          status: "Status",
          priority: "Prioridade",
          orderBy: "Ordenar por",
          user: "Usuário",
          all: "Todas",
          pending: "Pendentes",
          completed: "Concluídas",
          low: "Baixa",
          medium: "Média",
          high: "Alta",
          dueDateAsc: "Vencimento (mais antigo)",
          dueDateDesc: "Vencimento (mais recente)",
          priorityAsc: "Prioridade (baixa a alta)",
          priorityDesc: "Prioridade (alta a baixa)",
          createdAtAsc: "Mais antigo primeiro",
          createdAtDesc: "Mais recente primeiro",
        },
        priority: {
          low: "Baixa",
          medium: "Média",
          high: "Alta",
        },
        status: {
          pending: "Pendente",
          completed: "Concluída",
        },
        recurrence: {
          none: "Não repete",
          daily: "Diariamente",
          weekly: "Semanalmente",
          monthly: "Mensalmente",
        },
        reminder: {
          none: "Sem lembrete",
          minutes: "minutos",
          hour: "hora",
          hours: "horas",
          day: "dia",
          message: "Lembrete de tarefa",
          dialogTitle: "Lembrete de Tarefa",
          dialogScheduledFor: "Agendada para",
          dialogDismiss: "Entendi",
        },
        card: {
          dueDate: "Vencimento:",
          schedule: "Horário:",
          recurrence: "Repetição:",
          assignedTo: "Responsável:",
          createdBy: "Criado por:",
          noDescription: "Sem descrição",
          overdue: "Atrasada",
          dueToday: "Vence hoje",
        },
        pagination: {
          loadMore: "Carregar mais",
          loading: "Carregando...",
          loadPrevious: "Ver dias anteriores",
          noDate: "Sem data",
          overdueGroup: "Atrasadas",
        },
        table: {
          title: "Título",
          priority: "Prioridade",
          dueDate: "Vencimento",
          assignedTo: "Responsável",
          status: "Status",
          actions: "Ações",
        },
        modal: {
          newTitle: "Nova Tarefa",
          editTitle: "Editar Tarefa",
          titleField: "Título da Tarefa *",
          description: "Descrição",
          priority: "Prioridade",
          dueDate: "Data de Vencimento",
          assignTo: "Atribuir para",
          schedule: "Horários",
          startTime: "Hora Início",
          endTime: "Hora Fim",
          recurrence: "Repetição",
          reminder: "Lembrete",
          notifyBefore: "Notificar antes",
          reminderHelp: "Você receberá uma notificação antes do horário programado da tarefa.",
        },
        calendar: {
          weekDays: {
            sun: "Dom",
            mon: "Seg",
            tue: "Ter",
            wed: "Qua",
            thu: "Qui",
            fri: "Sex",
            sat: "Sáb",
          },
          months: {
            jan: "Janeiro",
            feb: "Fevereiro",
            mar: "Março",
            apr: "Abril",
            may: "Maio",
            jun: "Junho",
            jul: "Julho",
            aug: "Agosto",
            sep: "Setembro",
            oct: "Outubro",
            nov: "Novembro",
            dec: "Dezembro",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir Tarefa",
          deleteMessage: "Tem certeza que deseja excluir esta tarefa? Esta ação não pode ser desfeita.",
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
        tr: "Türkçe",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
          userId: "ID do usuário/atendente",
          queueId: "ID da Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        API: {
          title: "Documentação para envio de mensagens",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensagens de Texto",
            messagesMidia: "Mensagens de Media",
          },
          instructions: {
            title: "Instruções",
            comments: "Observações Importantes",
            comments1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. <br />Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
            comments2:
              "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
            codeCountry: "Código do País",
            code: "DDD",
            number: "Número",
          },
          text: {
            title: "1. Mensagens de Texto",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
        messageHidden: "Mensagem oculta",
        newMessage: "Nova mensagem de",
        transfer: "Ticket Transferido",
      },
      triggerFlowModal: {
        title: "Disparar Fluxo",
        description:
          "Selecione um fluxo para executar neste ticket. O ticket será alterado para status 'chatbot' durante a execução.",
        selectFlow: "Escolha um fluxo",
        selectedFlow: "Fluxo selecionado",
        flowId: "ID do fluxo",
        noFlows: "Nenhum fluxo ativo encontrado",
        cancel: "Cancelar",
        trigger: "Disparar Fluxo",
        triggering: "Disparando...",
        success: "Fluxo disparado com sucesso!",
        error: "Erro ao disparar fluxo",
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        noAttachment: "Sem anexo",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        selectMessage: "Selecionar Resposta Rápida",
        hasMedia: "Com mídia",
        global: "Global",
        noResultsFound: "Nenhuma resposta rápida encontrada para sua busca",
        noQuickMessages: "Nenhuma resposta rápida disponível",
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          general: "Geral",
          visao: "Permitir visão",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },

      kanban: {
        title: "Kanban",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Painel",
          tags: "Lanes",
        },
      },

      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Listagem",
          listContacts: "Lista de contatos",
          settings: "Configurações",
        },
        settings: {
          randomInterval: "Intervalo Randômico de Disparo",
          noBreak: "Sem Intervalo",
          intervalGapAfter: "Intervalo maior após",
          undefined: "Não definido",
          messages: "mensagens",
          laggerTriggerRange: "Intervalo de disparo maior",
          addVar: "Adicionar variável",
          save: "Salvar",
          close: "Fechar",
          add: "Adicionar",
          shortcut: "Atalho",
          content: "Conteúdo",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          option: "Nenhuma",
          disabled: "Desabilitada",
          enabled: "Habilitada",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          help: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          form: {
            name: "Nome",
            message: "Mensagem",
            messageVariation: "Variação",
            addVariation: "Adicionar variação",
            removeVariation: "Remover variação",
            confirmationMessage: "Mensagem de confirmação",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            channelInternal: "Interno",
            channelPlugin: "Plugin",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Tags",
            statusTicket: "Status do Ticket",
            openTicketStatus: "Aberto",
            pendingTicketStatus: "Pendente",
            closedTicketStatus: "Fechado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Desabilitado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
        },
      },
              campaignReport: {
          title: "Relatório de",
          inactive: "Inativa",
          scheduled: "Programada",
          process: "Em Andamento",
          cancelled: "Cancelada",
          finished: "Finalizada",
          campaign: "Campanha",
          validContacts: "Contatos Válidos",
          confirmationsRequested: "Confirmações Solicitadas",
          confirmations: "Confirmações",
          deliver: "Entregues",
          connection: "Conexão",
          contactLists: "Lista de Contatos",
          schedule: "Agendamento",
          conclusion: "Conclusão",
          fetchError: "Erro ao buscar dados do relatório",
          backButton: "Voltar",
        },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        active: "Ativo",
        inactive: "Inativo",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
            high: "Alta",
            medium: "Média",
            low: "Baixa",
            active: "Ativo",
            inactive: "Inativo",
            expiresAt: "Expira em",
            expiresAtHelp: "Deixe em branco para o informativo não expirar",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
      },
      queues: {
        title: "Filas & Chatbot",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          orderQueue: "Ordenação da fila (bot)",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar fila",
        },
        toasts: {
          success: "Fila salva com sucesso",
          deleted: "Fila exclu[ida com sucesso",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queue: {
        queueData: "Dados",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas somente leitura",
        withoutQueue: "Sem fila",
      },
      reports: {
        title: "Relatórios de Atendimentos",
        startDate: "Data Inicial",
        endDate: "Data final",
        table: {
          id: "Ticket",
          user: "Usuário",
          dateOpen: "Data Abertura",
          dateClose: "Data Fechamento",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Conexão",
          queue: "Fila",
          actions: "Ações",
          lastMessage: "Últ. Mensagem",
          contact: "Cliente",
          supportTime: "Tempo de Atendimento",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Apenas Avaliados",
        },
        searchPlaceholder: "Pesquisar...",
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
      },
      users: {
        title: "Usuários",
        table: {
          status: "Status",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Ativo",
          name: "Nome",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          plan: "Plano",
          active: "Ativo",
          numberAttendants: "Atendentes",
          numberConections: "Conexões",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Filas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Criada Em",
          dueDate: "Vencimento",
          lastLogin: "Ult. Login",
          serverId: "Instância",
          serverIdHelp: "Deixe vazio para definir no primeiro login",
          allServers: "Todas as instâncias",
          noServer: "Sem instância",
          folderSize: "Tamanho da pasta ",
          totalFiles: " Total de arquivos",
          lastUpdate: "Ultimo update",
          actions: "Ações",
          money: "R$",
          yes: "Sim",
          no: "Não",
          document: "CNPJ/CPF",
          recurrence: "Recorrência",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpar",
          delete: "Excluir",
          user: "Usuário",
          save: "Salvar",
          generateInvoice: "Gerar Fatura",
        },
        buttons: {
          add: "Adicionar empresa",
        },
        toasts: {
          deleted: "Empresa excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      plans: {
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "R$",
          public: "Público",
          trial: "Trial",
          trialDays: "Dias Trial",
        },
      },
      helps: {
        title: "Central de Ajuda",
        settings: {
          codeVideo: "Código do Video",
          description: "Descrição",
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
        },
      },
      schedules: {
        internalChip: "Interna",
        title: "Agendamentos",
        date: "Data",
        time: "Hora",
        event: "Evento",
        allDay: "Dia Todo",
        week: "Semana",
        work_week: "Agendamentos",
        day: "Dia",
        month: "Mês",
        previous: "Anterior",
        next: "Próximo",
        yesterday: "Ontem",
        tomorrow: "Amanhã",
        today: "Hoje",
        agenda: "Agenda",
        noEventsInRange: "Não há agendamentos no período.",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADICIONAR COLUNAS",
        search: "BUSCAR",
        seeTicket: "VER TICKET",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          id: "ID",
          name: "Nome",
          kanban: "Kanban",
          color: "Cor",
          tickets: "Registros Tags",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Tag",
        },
        toasts: {
          deleted: "Tag excluído com sucesso.",
        },
      },
      whatsappVersions: {
        title: "Versoes do WhatsApp",
        searchPlaceholder: "Buscar versao...",
        confirmationModal: {
          deleteTitle: "Excluir Versao",
          deleteMessage: "Voce tem certeza que deseja excluir esta versao?",
        },
        table: {
          version: "Versao",
          default: "Padrao",
          origin: "Origem",
          beta: "Beta",
          released: "Lancamento",
          expire: "Expira",
          actions: "Acoes",
        },
        labels: {
          default: "Padrao",
          fromUrl: "URL",
          manual: "Manual",
          beta: "Beta",
          cannotDeleteDefault: "Nao e possivel excluir a versao padrao",
        },
        buttons: {
          add: "Adicionar Versao",
          sync: "Sincronizar da URL",
          delete: "Excluir",
          setDefault: "Definir como padrao",
        },
        toasts: {
          deleted: "Versao excluida com sucesso",
          created: "Versao criada com sucesso",
          updated: "Versao atualizada com sucesso",
          defaultSet: "Versao definida como padrao",
          synced: "Sincronizacao concluida",
          newVersions: "novas versoes",
          updated: "atualizadas",
        },
      },
      whatsappVersionModal: {
        title: {
          add: "Adicionar Versao",
          edit: "Editar Versao",
        },
        form: {
          version: "Versao",
          versionHelp: "Formato: X.XXXX.XXXXXXXXXX (ex: 2.3000.1024710243)",
          setAsDefault: "Definir como versao padrao",
        },
        buttons: {
          cancel: "Cancelar",
          okAdd: "Adicionar",
          okEdit: "Salvar",
        },
      },

      tagsKanban: {
        title: "Lanes",
        laneDefault: "Em aberto",
        backToKanban: "VOLTAR PARA O KANBAN",

        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Lane?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Tickets",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lane",
        },
        toasts: {
          deleted: "Lane excluída com sucesso.",
        },
      },

      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        tabs: {
          options: "Opções",
          plans: "Planos",
          helps: "Ajuda",
          companies: "Empresas",
          externalLinks: "Links Externos",
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          tabs: {
            options: "Opções",
            schedules: "Horários",
            plans: "Planos",
            help: "Ajuda",
          },
          options: {
            disabled: "Desabilitado",
            enabled: "Habilitado",
            updating: "Atualizando...",
            mergeHistoryByContact: "Mesclar histórico entre conexões",
            mergeHistoryByContactHelp: "Exibe no ticket todas as conversas do contato, de todas as conexões, inclusive os atendimentos posteriores",
            creationCompanyUser: "Criação de Company/Usuário",
            evaluations: "Avaliações",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por Conexão",
            sendGreetingAccepted: "Enviar saudação ao aceitar o ticket",
            sendMsgTransfTicket:
              "Enviar mensagem transferência de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensagens de Grupos",
            chatBotType: "Tipo do Bot",
            userRandom: "Escolher atendente aleatório",
            buttons: "Botões",
            acceptCallWhatsapp: "Informar que não aceita ligação no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues:
              "Enviar saudação quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensagem com a posição da fila",
            sendFarewellWaitingTicket:
              "Enviar mensagem de despedida no Aguardando",
            acceptAudioMessageContact:
              "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para fechar ticket",
            closeTicketOnTransfer:
              "Fechar ticket ao transferir para outra fila",
            DirectTicketsToWallets:
              "Mover automaticamente cliente para carteira",
            showNotificationPending:
              "Mostrar notificação para tickets pendentes",
            tasksEnabled: "Habilitar módulo de Tarefas",
            testNotification: "Testar Notificação",
            testNotificationSuccess: "Notificação enviada! Se não apareceu, verifique as permissões de notificação do seu navegador/dispositivo.",
            testNotificationBlocked: "Notificações bloqueadas. Permita notificações nas configurações do seu navegador/dispositivo.",
            testNotificationUnsupported: "Este navegador não suporta notificações.",
            testNotificationTitle: "Teste de Notificação",
            testNotificationBody: "As notificações estão funcionando corretamente!",
            copyContactPrefix: "Sigla para Cópia de Contatos",
            copyContactPrefixPlaceholder: "Ex: COPIA_",

            // Configurações de vencimento do plano
            planExpiryTitle: "Configurações de Vencimento do Plano",
            gracePeriodDays: "Período de Tolerância - Sistema (Dias)",
            whatsappDisconnectGracePeriodDays: "Período de Tolerância - WhatsApp (Dias)",
            gracePeriodHelp: "Quantos dias após o vencimento o sistema continuará funcionando (0 = bloquear imediatamente)",
            disconnectWhatsappOnExpiry: "Desconectar WhatsApp ao Vencer",
            disconnectWhatsappHelp: "Se deve desconectar WhatsApp quando o plano vencer",
            planExpiryInfoTitle: "Como Funciona",
            planExpiryInfoTolerance: "Sistema continua funcionando após vencimento",
            planExpiryInfoWhatsapp: "Por padrão, não desconecta automaticamente",
            planExpiryInfoBlocking: "Ocorre apenas após período de tolerância",
            planExpiryInfoConfig: "Específica por empresa",

            // Opções de desconexão WhatsApp
            whatsappDisconnectNo: "Não (recomendado)",
            whatsappDisconnectYes: "Sim, desconectar automaticamente"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensagem de posição na fila",
            AcceptCallWhatsappMessage:
              "Mensagem para informar que não aceita ligações",
            greetingAcceptedMessage: "Mensagem de Saudação ao aceitar ticket",
            transferMessage:
              "Mensagem de transferência - ${queue.name} = fila destino",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensagem de boas vindas(LGPD)",
            linkLGPD: "Link da política de privacidade",
            obfuscateMessageDelete: "Ofuscar mensagem apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar número telefone para usuários",
            enabled: "Habilitado",
            disabled: "Desabilitado",
          },
        },
      },
      messagesList: {
        resendFailed: "Falha no envio — clique para reenviar",
        resendButton: "Reenviar",
        resending: "Reenviando...",
        resent: "Mensagem reenviada.",
        header: {
          assignedTo: "Atribuído à:",
          options: "+ Opções",
          dialogRatingTitle:
            "Deseja deixar uma avaliação de atendimento para o cliente?",
          dialogClosingTitle: "Finalizando o atendimento com o cliente!",
          dialogRatingCancel: "Resolver COM Mensagem de Despedida",
          dialogRatingSuccess: "Resolver e Enviar Avaliação",
          dialogRatingWithoutFarewellMsg: "Resolver SEM Mensagem de Despedida",
          ratingTitle: "Escolha um menu de avaliação",
          notMessage: "Nenhuma mensagem selecionada",
          amount: "Valor de prospecção",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            rating: "Enviar Avaliação",
            enableIntegration: "Habilitar integração",
            disableIntegration: "Desabilitar integração",
            logTicket: "Logs do Ticket",
            requiredTag: "Você deve atribuir uma tag antes de fechar o ticket.",
            greetingAcceptedMessage:
              "Você deve configurar uma mensagem de saudação ao aceitar o ticket.",
          },
          loadHistory: "Carregar Mensagens",
          loadingHistory: "Carregando...",
        },
        fileCard: {
          download: "clique para baixar",
          fallbackName: "arquivo",
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderOpen:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        privateMessage: "Mensagem Privada",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Outras informações",
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          user: "Atendente",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Setor",
          connection: "Conexão",
          scheduledDate: "Data do Agendamento",
        },
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        resolveWithNoFarewell: "Finalizar sem despedida",
        acceptAudioMessage: "Aceitar áudios do contato?",
        appointmentsModal: {
          title: "Observações do atendimento",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket do contato",
          titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Habilitar/Desabilitar Assinatura",
          privateMessage: "Habilitar/Desabilitar Mensagem Privada",
          meet: "Enviar link para videoconferencia",
          triggerFlow: "Disparar Fluxo",
        },
        type: {
          imageVideo: "Fotos e vídeos",
          cam: "Câmera",
          contact: "Contato",
          meet: "Vídeo chamada",
          template: "Template Meta",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        edit: "Editar",
        copy: "Copiar",
        copied: "Mensagem copiada!",
        download: "Baixar",
        forward: "Encaminhar",
        toForward: "Encaminhar",
        react: "Reagir",
        talkTo: "Conversar Com",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Faturas",
          details: "Detalhes",
          users: "Usuários",
          connections: "Conexões",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Data Venc.",
          action: "Ação",
        },
      },
      backendErrors: {
        ERR_PLUGIN_URL_TEMPLATE_GUESSABLE: "O molde precisa conter {tenantKey} ou {hash}: sem isso a URL de uma empresa seria adivinhável a partir da outra.",
        ERR_PLUGIN_URL_TEMPLATE_UNKNOWN_TOKEN: "O molde tem um campo que o gerador não conhece.",
        ERR_PLUGIN_URL_TEMPLATE_INVALID: "O molde não forma uma URL válida.",
        ERR_PLUGIN_URL_SECRET_MISSING: "Para usar {hash} é preciso configurar PLUGIN_URL_SECRET no servidor.",
        ERR_PLUGIN_IS_DEFAULT: "Este plugin é padrão da plataforma e não pode ser removido.",
        ERR_DEFAULT_PLUGIN_URL_REQUIRED: "Informe a URL do plugin.",
        ERR_DEFAULT_PLUGIN_ID_CHANGED: "O plugin nesse endereço mudou de identidade. Verifique a URL.",
        ERR_DEFAULT_PLUGIN_NOT_FOUND: "Plugin padrão não encontrado.",
        ERR_DEFAULT_PLUGIN_DUPLICATED: "Já existe um plugin padrão com este ID.",
        ERR_DEFAULT_PLUGIN_ID_REQUIRED: "Informe o ID do plugin.",
        ERR_DEFAULT_PLUGIN_NAME_REQUIRED: "Informe o nome do plugin.",
        ERR_DEFAULT_PLUGIN_ID_IMMUTABLE: "O ID do plugin não pode ser alterado.",
        ERR_PLUGIN_BASEURL_REQUIRED: "Informe a URL do plugin.",
        ERR_PLUGIN_COMPANY_NOT_DETECTED: "Empresa não identificada.",
        ERR_PLUGIN_UNREACHABLE: "Plugin indisponível ou não respondeu.",
        ERR_PLUGIN_PROVISION_FAILED: "Falha ao provisionar o plugin.",
        ERR_PLUGIN_NO_ID: "Metadata do plugin sem id.",
        ERR_PLUGIN_NOT_AUTHENTICATED: "Não autenticado.",
        ERR_PLUGIN_NOT_REGISTERED: "Plugin não registrado nesta empresa.",
        ERR_PLUGIN_IS_DEFAULT: "Este plugin é padrão da plataforma e não pode ser removido.",
        ERR_PLUGIN_URL_TAKEN: "Esta URL já está registrada por outra empresa.",
        ERR_PLUGIN_NO_LOGS: "Plugin não suporta logs ou não está ativo.",
        ERR_PLUGIN_CONN_FORBIDDEN: "Conexão não pertence a esta empresa.",
        ERR_PLUGIN_LOGS_FAILED: "Falha ao obter logs do plugin.",
        ERR_PLUGIN_INTERNAL: "Erro interno no plugin.",
        ERR_USER_LAST_ADMIN:
          "Não é possível alterar este perfil pois é o único administrador da empresa. Defina outro usuário como administrador antes de alterar este registro.",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_MEDIA_DOWNLOAD_FAILED: "Falha ao obter o arquivo do WhatsApp. O arquivo pode não ter sido baixado corretamente ou foi removido.",
        ERR_MEDIA_EXPIRED_ON_WHATSAPP: "Esta mídia expirou no WhatsApp e não pode mais ser baixada.",
        ERR_RETRY_DOWNLOAD_FAILED: "Falha ao tentar baixar novamente.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do Horário de Expediente!",

        // Erros de documentos
        ERR_DOCUMENT_ALREADY_EXISTS: "Este documento já está cadastrado para outro contato na empresa.",
        ERR_INVALID_CPF: "CPF inválido. Verifique os dígitos informados.",
        ERR_INVALID_CNPJ: "CNPJ inválido. Verifique os dígitos informados.",
        ERR_INVALID_DOCUMENT: "Documento inválido. Verifique o tipo e os dígitos informados.",
        ERR_CPF_LENGTH: "CPF deve ter exatamente 11 dígitos.",
        ERR_CNPJ_LENGTH: "CNPJ deve ter exatamente 14 dígitos.",
        ERR_OUTRO_LENGTH: "Documento deve ter no máximo {{max}} caracteres.",
      },
      documents: {
        type: "Tipo",
        number: "Número do Documento",
        placeholder: "Digite CPF, CNPJ ou outro documento",
        addDocument: "+ Adicionar Documento",
        cpf: "CPF",
        cnpj: "CNPJ",
        outro: "Outro",
        label: "Rótulo",
        labelPlaceholder: "Ex: Inscrição Estadual",
        labelRequired: "Informe o nome do documento",
        labelMaxLength: "Rótulo deve ter no máximo {{max}} caracteres",
        typeRequired: "Tipo é obrigatório",
        numberRequired: "Número do documento é obrigatório",
        cpfLength: "CPF deve ter 11 dígitos",
        cpfInvalid: "CPF inválido",
        cnpjLength: "CNPJ deve ter 14 caracteres",
        cnpjInvalid: "CNPJ inválido",
        outroRequired: "Documento é obrigatório",
        outroMaxLength: "Documento deve ter no máximo {{max}} caracteres",
        fullFormMessage: "Para adicionar documentos, use o formulário completo de contatos.",
        duplicateWarning: "{{type}} {{number}} também está cadastrado em: {{contacts}}"
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) e Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensagem"',
        fieldUserId: '"userId": ID do usuário ou ""',
        fieldQueueId: '"queueId": ID da Fila ou ""',
        fieldSendSignature: '"sendSignature": Assinar mensagem - true/false',
        fieldCloseTicket: '"closeTicket": Encerrar o ticket - true/false',
        singMessage: "Assinar mensagem - true/false",
        closeTicket: "Encerrar o ticket - true/false",
        testSend: "Teste de envio",
      },
      recurrenceSection: {
        title: "Recorrência",
        description:
          "Você pode escolher enviar a mensagem de forma recorrente e escolher o intervalo. Caso seja uma mensagem a ser enviada uma única vez, não altere nada nesta seção.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor do Intervalo",
        sendAsManyTimes: " Enviar quantas vezes",
        shipNormallyOnNonbusinessDays: " Enviar normalmente em dias não úteis",
        sendOneBusinessDayBefore: "Enviar um dia útil antes",
        sendOneBusinessDayLater: "Enviar um dia útil depois",
        options: {
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Painel de Atendimentos",
      },
      financial: {
        invoices: "Faturas",
        details: "Detalhes",
        users: "Usuários",
        connections: "Conexões",
        queues: "Filas",
        value: "Valor",
        expirationDate: "Data Venc.",
        status: "Status",
        action: "Ação",
      },
      statusFilter: {
        statusFilter: "Filtro por Status",
      },
      momentsUser: {
        services: "Atendimentos:",
        pending: "Pendentes",
        noqueue: "SEM FILA",
      },
      campaignsPhrase: {
        campaignsFlow: "Fluxo de Campanhas",
        campaigns: "Campanhas",
        name: "Nome",
        status: "Status",
        newCampaignWithFlowByPhrase: "Nova campanha com fluxo por frase",
        editCampaignWithFlowByPhrase: "Editar campanha com fluxo por frase",
        phraseTriggerName: "Nome do disparo por frase",
        chooseAStream: "Escolha um fluxo",
        whichPhraseTriggersTheFlow: " Qual frase dispara o fluxo?",
        selectAConnection: " Selecione uma Conexão",
        chooseAStream: " Escolha um fluxo",
        status: " Status",
        cancel: "CANCELAR",
        createCampaign: "CRIAR CAMPANHA ",
        saveCampaign: "Salvar Campanha",
      },
      whatsappModalRel: {
        form: {
          isOficial: "Relatório do Atendimento",
          ticketId: "ID do Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Atendente",
          date: "Data",
          lastMessage: "Última Mensagem",
          fullReport: "O relatório completo foi anexado acima",
          resolveAndTriggerIntegration: "Resolver e Disparar Integração",
          elementNotFoundForExport: "Elemento não encontrado para exportar.",
          reportFilename: "relatório_atendimento",
        },
      },
      chatList: {
        noMessages: "Nenhuma mensagem",
        admin: "Administrador",
        member: "Membro",
        searchChat: "Procurar chat...",
        createNewChat: "Criar novo chat",
        searchUser: "Procurar usuário...",
        noUserFound: "Nenhum usuário encontrado",
        noUserAvailable: "Nenhum usuário disponível",
        cancel: "Cancelar",
        details: "Detalhes",
        deleteChat: "Excluir Conversa",
        deleteChatConfirm: "Esta ação não pode ser revertida, confirmar?",
        detailsTitle: "Detalhes",
        edit: "Editar",
        delete: "Excluir",
        now: "agora",
        minutesAgo: "{{count}}m atrás",
        hoursAgo: "{{count}}h atrás",
      },
      chatMessages: {
        deleted: "Esta mensagem foi apagada",
        deletedAdmin: "Mensagem apagada - visível apenas para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        cancel: "Cancelar",
        deleteMessage: "Deletar Mensagem",
        deleteMessageConfirm: "Tem certeza que deseja deletar esta mensagem?",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        doubleClickToReply: "Clique duas vezes para responder",
        edited: "(editada)",
        forwarded: "(encaminhada)",
        typeMessage: "Digite uma mensagem...",
        send: "Enviar",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        replyingTo: "Respondendo a",
        clickToGoToOriginal: "Clique para ir até a mensagem original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Exclusão",
        confirm: "Confirmar",
        deleteMessage: "Tem certeza que deseja excluir esta mensagem?",
        editMessage: "Editar Mensagem",
        save: "Salvar",
        forwardMessage: "Encaminhar Mensagem",
        selectChat: "Selecione o chat",
        forward: "Encaminhar",
        noChats: "Nenhum chat disponível",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Novo",
        messages: "Mensagens",
        search: "Buscar...",
        noChats: "Nenhum chat encontrado",
        noGroups: "Nenhum grupo encontrado",
        noMessages: "Nenhuma mensagem",
        loading: "Carregando...",
        error: "Erro ao carregar dados",
        addGroupPhoto: "Adicionar Foto do Grupo",
        changeGroupPhoto: "Alterar Foto do Grupo",
        groupName: "Nome do Grupo",
        groupDescription: "Descrição do Grupo",
        save: "Salvar",
        cancel: "Cancelar",
        createGroup: "Criar Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Deletar Grupo",
        deleteGroupConfirm: "Tem certeza que deseja deletar este grupo?",
        edit: "Editar",
        delete: "Excluir",
        details: "Detalhes",
        groupDetails: "Detalhes do Grupo",
        title: "Título",
        description: "Descrição",
        modal: {
          title: "Criar grupo",
          name: "Nome do grupo",
          description: "Descrição do grupo",
          create: "Criar",
          cancel: "Cancelar",
          save: "Salvar",
          edit: "Editar",
        },
        modal: {
          title: "Criar Grupo",
          editTitle: "Editar Grupo",
          save: "Salvar",
          cancel: "Cancelar",
        },
      },
whitelabel: {
        primaryColorLight: "Cor Primária (Tema Claro)",
        primaryColorDark: "Cor Primária (Tema Escuro)",
        appName: "Nome da Aplicação",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Escuro)",
        favicon: "Favicon",
        backgroundLight: "Imagem de Fundo (Tema Claro)",
        backgroundDark: "Imagem de Fundo (Tema Escuro)",
        preview: "Visualizar",
        delete: "Excluir",
        upload: "Enviar",
        availableLanguages: "Idiomas Disponíveis",
        atLeastOneLanguage: "Pelo menos um idioma deve estar habilitado",

        sections: {
          general: "Configurações Gerais",
          generalDescription: "Configure o nome e informações básicas da aplicação",
          colors: "Cores e Temas",
          colorsDescription: "Personalize as cores primárias para temas claro e escuro",
          logos: "Logos e Imagens",
          logosDescription: "Carregue os logos e imagens de fundo da aplicação",
          languages: "Idiomas Disponíveis",
          languagesDescription: "Selecione quais idiomas estarão disponíveis no sistema"
        }
      },
      crmSettings: {
        title: "Integração CRM",
        description: "Configure o tipo de gerenciamento de faturas e os endpoints do CRM externo",
        invoiceManagementType: "Tipo de Gerenciamento de Fatura",
        invoiceManagementNone: "Nenhum",
        urlInvoiceByCnpj: "URL consulta fatura por CNPJ",
        urlInvoiceByCnpjHelper: "Endpoint do CRM para consultar faturas pelo CNPJ do cliente",
        authorizationByCnpj: "Authorization (Fatura por CNPJ)",
        urlInvoiceById: "URL consulta fatura por Invoice ID",
        urlInvoiceByIdHelper: "Endpoint do CRM para consultar faturas pelo ID da fatura",
        authorizationById: "Authorization (Fatura por ID)",
        authorizationHelper: "Token de autorização (ex: Bearer xxxxxxxx)",
        billingCheckTime: "Verificação de Faturas",
        testButton: "Executar Verificação Agora",
        testRunning: "Verificando...",
        testSuccess: "Verificação de faturas executada com sucesso",
        testError: "Erro ao executar verificação de faturas",
      },
      companyUsage: {
        settings: {
          title: "Coleta de uso por empresa",
          description: "Define quando o sistema fará o snapshot diário de mensagens, arquivos, contatos e tickets de cada empresa.",
          cronLabel: "Coleta de uso",
          incrementalLabel: "Modo incremental",
          incrementalHelp: "Quando habilitado, processa só as mensagens novas desde o último snapshot (rápido). Quando desabilitado, faz scan completo da tabela toda vez (lento, mas 100% preciso).",
        },
        page: {
          title: "Consumo",
          tabOwn: "Minha empresa",
          tabAll: "Todas as empresas",
          lastSnapshot: "Último snapshot",
          refreshNow: "Atualizar agora",
          nextRunIn: "Próxima coleta em",
          refreshSuccess: "Snapshot atualizado",
          recalculate: "Recalcular",
          recalculateSuccess: "Recalculado",
          update: "Atualizar",
          metrics: {
            messages: "Mensagens",
            messagesSize: "Tamanho das mensagens",
            files: "Arquivos",
            filesSize: "Tamanho dos arquivos",
            contacts: "Contatos",
            contactsSize: "Tamanho dos contatos",
            tickets: "Tickets",
            ticketsSize: "Tamanho dos tickets",
          },
          chart: {
            title: "Evolução do consumo",
            daily: "Diário",
            weekly: "Semanal",
            monthly: "Mensal",
            empty: "Pelo menos 2 snapshots são necessários para gerar o gráfico.",
            messages: "Mensagens",
            mbMessages: "MB Mensagens",
            mbFiles: "MB Arquivos",
          },
          history: {
            title: "Histórico (últimos snapshots)",
            empty: "Nenhum snapshot ainda",
            colDate: "Data",
            colMessages: "Mensagens",
            colMbMessages: "MB Mensagens",
            colFiles: "Arquivos",
            colMbFiles: "MB Arquivos",
            rowsPerPage: "Linhas por página",
          },
          admin: {
            colCompany: "Empresa",
            colSnapshot: "Snapshot",
            colActions: "Ações",
          },
        },
      },
      externalLinks: {
        openModes: {
          iframe: "Dentro do sistema",
          newTab: "Nova aba do navegador",
        },
        title: "Links Externos",
        noLinks: "Nenhum link externo cadastrado",
        noLinksDescription: "Clique no botão acima para adicionar um novo link",
        buttons: {
          add: "Adicionar Link",
          save: "Salvar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          url: "URL",
          userType: "Tipo de Usuário",
          active: "Ativo",
          actions: "Ações",
        },
        userTypes: {
          all: "Todos",
          admin: "Administrador",
          user: "Usuário",
          specific: "Usuários Específicos",
        },
        form: {
          name: "Nome do Link",
          url: "URL",
          urlHelper: "Insira a URL completa incluindo https://",
          openMode: "Abrir em",
          checkingEmbed: "Verificando se o site permite ser exibido aqui...",
          embedBlocked:
            "Este site não permite ser exibido dentro de outro sistema (é uma proteção do próprio site, como no Google e no ChatGPT). Ele será aberto em uma nova aba.",
          icon: "Ícone",
          userType: "Visível para",
          order: "Ordem",
          active: "Ativo",
          selectUsers: "Selecionar Usuários",
          searchUsers: "Buscar usuários...",
          specificUsersHelp: "Apenas os usuários selecionados terão acesso a este link",
        },
        modal: {
          addTitle: "Adicionar Link Externo",
          editTitle: "Editar Link Externo",
        },
        confirmDelete: {
          title: "Excluir Link",
          message: "Tem certeza que deseja excluir este link externo? Esta ação não pode ser desfeita.",
        },
        toasts: {
          created: "Link externo criado com sucesso!",
          updated: "Link externo atualizado com sucesso!",
          deleted: "Link externo excluído com sucesso!",
          errorLoading: "Erro ao carregar links externos",
          errorSaving: "Erro ao salvar link externo",
          errorDeleting: "Erro ao excluir link externo",
          errorUpdating: "Erro ao atualizar link externo",
          requiredFields: "Preencha todos os campos obrigatórios",
          invalidUrl: "URL inválida",
        },
      },
      externalIframe: {
        loading: "Carregando...",
        loadingPage: "Carregando página...",
        back: "Voltar",
        openNewTab: "Abrir em nova aba",
        errors: {
          linkNotFound: "Link não encontrado",
          generic: "Erro ao carregar o link",
        },
        blocked: {
          title: "Este site não pode ser exibido aqui",
          description: "O próprio site bloqueia ser exibido dentro de outra página — é uma proteção contra golpes, usada por Google, Gmail, Drive, Docs e ChatGPT, e não há como contorná-la por aqui. Abra em uma nova aba para usá-lo normalmente, já com o seu login.",
        },
      },
      installPWA: {
        title: "Instalar Aplicativo",
        message: "Instale o app para uma experiência mais rápida e acesso direto pela tela inicial.",
        installButton: "Instalar",
        dismissButton: "Agora não",
        iosInstructions: "Para instalar: toque em {{shareIcon}} e depois \"Adicionar à Tela de Início\"",
      },
      termsOfUse: {
        title: "Termos de Uso",
        agreeLabel: "Concordo com os termos de uso",
        scrollHint: "Leia os termos até o final para habilitar a opção de aceite",
        confirmButton: "Confirmar",
        exitButton: "Sair",
        settingsTitle: "Termos de Uso",
        uploadDescription: "Faça upload do arquivo .docx com os termos de uso. Este arquivo será exibido para novos usuários no primeiro acesso ao sistema.",
        selectFile: "Selecionar Arquivo",
        uploadButton: "Enviar Termos",
        uploading: "Enviando...",
        uploadSuccess: "Termos de uso atualizados com sucesso!",
        uploadError: "Erro ao enviar termos de uso.",
        invalidFileType: "Use somente arquivos no formato .docx!",
        previewButton: "Visualizar",
        previewEmpty: "Nenhum termo de uso encontrado no servidor.",
        previewError: "Erro ao carregar termos de uso.",
        closeButton: "Fechar",
      },
    },
  },
};

export { messages };
